export default "__VITE_ASSET__DriO8cK2__"